import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { authAxios } from "../../utils/axiosConfig";
import { checkPasswordStrength } from "../../utils/passwordChecker";
import ButtonComponent from "../Button";
import PasswordStrengthIndicator from "../PasswordStrengthIndicator";
import PasswordInputChecker from "../PasswordInputChecker";
import "../../styles/authForm.css";

const Signup = () => {
	const initialState = {
		firstname: "",
		lastname: "",
		address: "",
		gender: "",
		role: "",
		email: "",
		password: "",
		confirmPassword: "",
	};
	const navigate = useNavigate();
	const { isLoggedIn, role } = useSelector((state) => state.auth);
	const [data, setData] = useState(initialState);
	const [inputPassword, setInputPassword] = useState("");
	const [passwordStrengthValue, setPasswordStrengthValue] = useState(0);

	useEffect(() => {
		isLoggedIn && role === "admin"
			? navigate("/signup")
			: navigate("/signin");
	}, [isLoggedIn, role]);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setData({ ...data, [name]: value });
	};

	const handlePassword = (e) => {
		const inputPassword = e.target.value;
		setInputPassword(inputPassword);
		setData({ ...data, password: inputPassword });

		const strengthValue = checkPasswordStrength(inputPassword);
		setPasswordStrengthValue(strengthValue);
	};

	const handleRegisterUser = async (e) => {
		e.preventDefault();
		const {
			email,
			firstname,
			lastname,
			address,
			gender,
			role,
			password,
			confirmPassword,
		} = data;

		try {
			const { data } = await authAxios.post("/api/users", {
				email,
				firstname,
				lastname,
				address,
				gender,
				role,
				password,
				confirmPassword,
			});

			if (data.error) {
				toast.error(data.error);
			} else {
				toast.success("New User Registered Successfully!");
				setData(initialState);
				setInputPassword("");
				setPasswordStrengthValue(0);
			}
		} catch (error) {
			return { error: error.message };
		}
	};

	return (
		<div className="component_wrapper">
			<h2 className="sub_title">Register User</h2>

			<form
				onSubmit={handleRegisterUser}
				className="form_container auth_register"
			>
				<section className="input_group1">
					<h3 className="register_subtitle">Personal info</h3>
					<div className="input_container">
						<label htmlFor="firstname"> Firstname </label>
						<input
							name="firstname"
							type="text"
							placeholder="John"
							value={data.firstname}
							onChange={(e) =>
								setData({ ...data, firstname: e.target.value })
							}
							autoComplete="on"
							className="input_area"
						/>
					</div>
					<div className="input_container">
						<label htmlFor="lastname"> Lastname </label>
						<input
							name="lastname"
							type="text"
							placeholder="Doe"
							value={data.lastname}
							onChange={(e) =>
								setData({ ...data, lastname: e.target.value })
							}
							autoComplete="on"
							className="input_area"
						/>
					</div>
					<div className="input_container">
						<label htmlFor="address"> Address </label>
						<input
							name="address"
							type="text"
							placeholder="Address"
							value={data.address}
							onChange={(e) =>
								setData({ ...data, address: e.target.value })
							}
							autoComplete="on"
							className="input_area"
						/>
					</div>
					<div className="input_container">
						<label htmlFor="gender"> Gender </label>
						<select
							id="gender"
							name="gender"
							value={data.gender}
							onChange={handleInputChange}
							className="input_area"
						>
							<option
								value=""
								className="form_option"
							>
								Select below
							</option>
							<option
								value="male"
								className="form_option"
							>
								Male
							</option>
							<option
								value="female"
								className="form_option"
							>
								Female
							</option>
						</select>
					</div>
					<div className="input_container">
						<label htmlFor="role"> Role </label>
						<select
							id="role"
							name="role"
							value={data.role}
							onChange={handleInputChange}
							className="input_area"
						>
							<option
								value=""
								className="form_option"
							>
								Select below
							</option>
							<option
								value="user"
								className="form_option"
							>
								User
							</option>
							<option
								value="admin"
								className="form_option"
							>
								Admin
							</option>
						</select>
					</div>
				</section>

				<section className="input_group2">
					<h3 className="register_subtitle">Login Info</h3>
					<div>
						<div className="input_container">
							<label htmlFor="email"> Email </label>
							<input
								name="email"
								type="email"
								placeholder="your@email.com"
								value={data.email}
								onChange={(e) =>
									setData({
										...data,
										email: e.target.value.toLocaleLowerCase(),
									})
								}
								autoComplete="on"
								className="input_area"
							/>
						</div>
						<div className="input_container">
							<label htmlFor="password"> Password </label>
							<input
								name="password"
								type="password"
								placeholder="Password"
								value={data.password}
								onChange={handlePassword}
								className="input_area"
							/>
						</div>
						<div className="input_container">
							<label htmlFor="confirmPassword">Confirm password</label>
							<input
								name="confirmPassword"
								type="password"
								placeholder="Re-enter password"
								value={data.confirmPassword}
								onChange={(e) =>
									setData({ ...data, confirmPassword: e.target.value })
								}
								className="input_area"
							/>
						</div>
					</div>
					<ButtonComponent
						type="submit"
						name="Register"
						className="btn_primary btn_auth"
					/>

					<div className="password_status_container">
						<PasswordStrengthIndicator
							passwordStrengthValue={passwordStrengthValue}
						/>
						<PasswordInputChecker inputPassword={inputPassword} />
					</div>
				</section>
			</form>
		</div>
	);
};

export default Signup;
